/* eslint-disable unicorn/prefer-module */
/* eslint-disable max-len */
/* eslint-disable prettier/prettier */
/* eslint-disable no-console */
import { useState } from "react";
import toast from "react-hot-toast";
import { getContratos, updateContrato } from "../../../utils";

export const useVFEdificiosModal = ({ setTodasOportunidades, pais }) => {
  const [showEdificiosModal, setShowEdificiosModal] = useState(false);
  const [edificiosMesTarget, setEdificiosMesTarget] = useState(null);

  const handleOpenEdificios = (oportunidad) => {
    setEdificiosMesTarget(oportunidad);
    setShowEdificiosModal(true);
  };

  const handleSaveEdificios = async (idsString, edificiosTotales, pantallasTotales, personasAsignadas, perTypeData) => {
    if (!edificiosMesTarget) return;
    try {
      const contratosRaw = await getContratos({ pais });
      const contrato = contratosRaw.find((c) => c.id === edificiosMesTarget.contrato_id);
      if (!contrato) throw new Error("Contrato no encontrado");
      const updatedMeses = [...(contrato.meses || [])];
      updatedMeses[edificiosMesTarget.mes_index] = {
        ...updatedMeses[edificiosMesTarget.mes_index],
        edificios_ids: idsString || null,
        edificios_totales: edificiosTotales,
        pantallas_totales: pantallasTotales,
        personas_asignadas: personasAsignadas,
        pantallas_ascensores: perTypeData?.pantallas_ascensores || "",
        pantallas_espera: perTypeData?.pantallas_espera || "",
        pantallas_circulacion: perTypeData?.pantallas_circulacion || "",
        pantallas_cowork: perTypeData?.pantallas_cowork || "",
      };
      await updateContrato({ id: contrato.id, contrato: { meses: updatedMeses } });
      toast.success("Edificios asignados correctamente");
      // Actualizar state local sin recargar página
      const updatedMesData = updatedMeses[edificiosMesTarget.mes_index];
      setTodasOportunidades((prev) =>
        prev.map((op) =>
          op.id === edificiosMesTarget.id
            ? {
                ...op,
                edificios_ids: updatedMesData.edificios_ids,
                pantallastotales: updatedMesData.pantallas_totales || 0,
                pantallas_ascensores: updatedMesData.pantallas_ascensores || "",
                pantallas_espera: updatedMesData.pantallas_espera || "",
                pantallas_circulacion: updatedMesData.pantallas_circulacion || "",
                pantallas_cowork: updatedMesData.pantallas_cowork || "",
              }
            : op
        )
      );
      setShowEdificiosModal(false);
      setEdificiosMesTarget(null);
    } catch (err) {
      console.error("Error asignando edificios:", err);
      toast.error("Error al asignar edificios");
    }
  };

  return {
    showEdificiosModal,
    setShowEdificiosModal,
    edificiosMesTarget,
    setEdificiosMesTarget,
    handleOpenEdificios,
    handleSaveEdificios,
  };
};
